import {orderAction} from "../OrderActions";
import {DiscriminationConfiguration, initialDiscriminationState, DiscriminationEntryExclusion, DiscriminationRule} from "./discriminationTypes";
import {menuAction} from "../../menu/MenuActions";
import {ApplicationState} from "../../../store";
import {discriminationAction} from "./discriminationActions";
import * as OrderTypes from "../OrderTypes";
import { number } from "react-i18next/icu.macro";

export const discriminationReducer = (state: ApplicationState, action: any): ApplicationState => {
    switch (action.type) {
        case discriminationAction.RECEIVE_DISCRIMINATIONRULES:
            const configuration = action.payload as DiscriminationConfiguration;

            //1 courseGroup can be in more sets
            const courseGroupSets: { [courseGroup: number]: number[] } = {};
            const foodItemDiscriminationSetMap: { [foodItemId: number]: number[] } = {};
            const foodItemSetDiscriminationMap: { [foodItemId: number]: number[] } = {};

            // const foodItems = (state: ApplicationState): number[] => state.menu.menu.foodItemKeys;

            let portionCounter: { [ruleId: number]: number } = {};
            let vseCounter: { [ruleId: number]: number } = {};
            let typeCounter: { [ruleId: number]: number } = {};

            //initialize count 0 for all rules
            configuration.rulesList.forEach(ruleId => {
                portionCounter[ruleId] = 0;
                vseCounter[ruleId] = 0;
                typeCounter[ruleId] = 0;
                configuration.rules[ruleId].components.forEach(compId => {
                    if (!courseGroupSets.hasOwnProperty(compId)) {
                        courseGroupSets[compId] = [];
                    }
                    courseGroupSets[compId].push(ruleId);
                });
            });

            for (let key in state.menu.menu.courseGroups) {
                let courseGroup = state.menu.menu.courseGroups[+key];
                courseGroupSets[courseGroup.id].forEach(setId => {
                    let courseGroupRule = configuration.rules[setId]; //courseGroup.discriminationSetNumber
                    if (courseGroupRule) {
                        courseGroup.foodItems.forEach(foodItemNr => {

                            if (!foodItemDiscriminationSetMap.hasOwnProperty(foodItemNr)) {
                                foodItemDiscriminationSetMap[foodItemNr] = [];
                            }
                            foodItemDiscriminationSetMap[foodItemNr].push(setId); //courseGroup.discriminationSetNumber
                            if (!courseGroupRule.foodItems) {
                                courseGroupRule.foodItems = [+foodItemNr];
                            } else {
                                courseGroupRule.foodItems.push(+foodItemNr);
                            }

                            let currentPortion: OrderTypes.ItemPortion = state.order.itemPortions[foodItemNr];
                            if (currentPortion && currentPortion.portion !== 0) {
                                portionCounter[courseGroupRule.setNr] += currentPortion.portion;
                                vseCounter[courseGroupRule.setNr] += currentPortion.portion * (currentPortion.vsePerPortion === 0 ? 1 : currentPortion.vsePerPortion);
                                typeCounter[courseGroupRule.setNr] += 1;
                            }
                        });

                    }
                });
            }

            for (let key in state.menu.menu.courseGroups) {
                let courseGroup = state.menu.menu.courseGroups[+key];
                let foodItemSetRules = configuration.exclusionsFoodItemSetList;

                let nutritionToCheck: number = 0;
                for (key in foodItemSetRules) {                    
                    if (foodItemSetRules[key].exceptionNutritionNr === courseGroup.nutritionNr && foodItemSetRules[key].exceptionNutritionNr !== 0) {
                        nutritionToCheck = courseGroup.nutritionNr;
                    }
                };

                courseGroup.foodItems.forEach(foodItemNr => {
                    let convertedFoodItem = foodItemNr - (100000000 * courseGroup.id);
                    for (let foodItemSetKey in foodItemSetRules) {
                        let exceptionSet = foodItemSetRules[+foodItemSetKey].exceptionChosenFoodItems;
                        /*if (courseGroup.nutritionNr === foodItemSetRules[+foodItemSetKey].exceptionNutritionId || foodItemSetRules[+foodItemSetKey].exceptionNutritionId === 0)*/
                        if (nutritionToCheck === foodItemSetRules[+foodItemSetKey].exceptionNutritionNr)
                        {
                            for (let fi in exceptionSet) {
                                if (exceptionSet[+fi] === convertedFoodItem) {
                                    if (!foodItemSetDiscriminationMap.hasOwnProperty(foodItemNr)) {
                                        foodItemSetDiscriminationMap[foodItemNr] = [];
                                    }
                                    let forbiddenExclusionSet = foodItemSetRules[+foodItemSetKey].exceptionForbiddenFoodItems;
                                    for (let ffi in forbiddenExclusionSet) {
                                        let found = false;
                                        if (foodItemSetDiscriminationMap[foodItemNr].length === 0) {
                                            foodItemSetDiscriminationMap[foodItemNr].push(forbiddenExclusionSet[+ffi]);
                                        }
                                        else {
                                            foodItemSetDiscriminationMap[foodItemNr].forEach(fi => {
                                                if (fi === forbiddenExclusionSet[+ffi]) {
                                                    found = true;
                                                }
                                            })
                                            if (!found) {
                                                foodItemSetDiscriminationMap[foodItemNr].push(forbiddenExclusionSet[+ffi]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            }

            for (let key in state.menu.menu.courseGroups) {
                let courseGroup = state.menu.menu.courseGroups[+key];
                let foodItemRules = configuration.exclusions;

                let nutritionToCheck: number = 0;
                for (key in foodItemRules) {
                    if (foodItemRules[key].entryExclusionNutritionNr === courseGroup.nutritionNr && foodItemRules[key].entryExclusionNutritionNr !== 0) {
                        nutritionToCheck = courseGroup.nutritionNr;
                    }
                };

                courseGroup.foodItems.forEach(foodItemNr => {
                    let convertedFoodItem = foodItemNr - (100000000 * courseGroup.id);
                    for (let foodItemKey in foodItemRules) {
                        let exclusionEntryNr = foodItemRules[+foodItemKey].entryExclusionEntryNr;
                        /*if (courseGroup.nutritionNr === foodItemSetRules[+foodItemSetKey].exceptionNutritionId || foodItemSetRules[+foodItemSetKey].exceptionNutritionId === 0)*/
                        if (nutritionToCheck === foodItemRules[+foodItemKey].entryExclusionNutritionNr) {                            
                            if (exclusionEntryNr === convertedFoodItem) {
                                if (!foodItemSetDiscriminationMap.hasOwnProperty(foodItemNr)) {
                                    foodItemSetDiscriminationMap[foodItemNr] = [];
                                }
                                let forbiddenExclusionSet = foodItemRules[+foodItemKey].entryExclusionForbiddenFoodItems;
                                for (let ffi in forbiddenExclusionSet) {
                                    let found = false;
                                    if (foodItemSetDiscriminationMap[foodItemNr].length === 0) {
                                        foodItemSetDiscriminationMap[foodItemNr].push(forbiddenExclusionSet[+ffi]);
                                    }
                                    else {
                                        foodItemSetDiscriminationMap[foodItemNr].forEach(fi => {
                                            if (fi === forbiddenExclusionSet[+ffi]) {
                                                found = true;
                                            }
                                        })
                                        if (!found) {
                                            foodItemSetDiscriminationMap[foodItemNr].push(forbiddenExclusionSet[+ffi]);
                                        }
                                    }
                                }
                            }                            
                        }
                    }
                });
            }

            //for (let exclusionKey in configuration.exclusions) {
            //    let exclusion: DiscriminationEntryExclusion = configuration.exclusions[exclusionKey];

            //    exclusion.entryExclusionSets.forEach(setNr => {
            //        let rule: DiscriminationRule = configuration.rules[setNr];
            //        if (!exclusion.entryExceptionForbiddenEntries) {
            //            exclusion.entryExceptionForbiddenEntries = rule.foodItems;
            //        } else {
            //            exclusion.entryExceptionForbiddenEntries = exclusion.entryExceptionForbiddenEntries.concat(rule.foodItems);
            //        }
            //    });
            //}

            return {
                ...state,
                discrimination: {
                    configuration: configuration,
                    ruleByFoodItem: foodItemDiscriminationSetMap,
                    ruleByFoodItemSet: foodItemSetDiscriminationMap,
                    rulePortionCounter: portionCounter,
                    ruleVSECounter: vseCounter,
                    ruleTypeCounter: typeCounter,
                    courseGroupSets: courseGroupSets
                }
            };

        case orderAction.CHANGE_PORTION:

            const discrimination = state.discrimination;
            //disc. rules houden een lijst bij van totale porties per ruleset
            
            const foodItemNr: number = action.payload.id;
            const foodItem = state.menu.menu.foodItems[foodItemNr];
            const currentPortion: number = action.payload.currentPortion;
            const newPortion: number = action.payload.newPortion;
            const diff = newPortion - currentPortion;
            const diffVSE = (newPortion - currentPortion) * foodItem.vsePerPortion;

            const rules = discrimination.ruleByFoodItem[foodItemNr]

            if (rules) {
                //rules available for foodItem
                let rulePortionCounters = { ...discrimination.rulePortionCounter };
                let ruleVSECounters = { ...discrimination.ruleVSECounter };
                let ruleTypeCounters = { ...discrimination.ruleTypeCounter };
                rules.forEach(setNr => {
                    //Portioncounter
                    rulePortionCounters[setNr] += diff;
                    //VSEcounter
                    ruleVSECounters[setNr] += diffVSE;
                    //Typecounter
                    if (newPortion === 0 && currentPortion > 0) {
                        ruleTypeCounters[setNr] -= 1;
                    }                   
                    if (newPortion > 0 && currentPortion === 0) {
                        ruleTypeCounters[setNr] += 1;
                    }
                });

                return {
                    ...state,
                    discrimination: {
                        ...discrimination,
                        rulePortionCounter: rulePortionCounters,
                        ruleVSECounter: ruleVSECounters,
                        ruleTypeCounter: ruleTypeCounters
                    }
                };

            }
            break;
        case menuAction.RECEIVE_MENU:
            return {
                ...state,
                discrimination: initialDiscriminationState
            }
        default:
            return state;
    }
    return state;
}
